export default __webpack_public_path__ + "static/media/bibi.cf419d4c.png";